// extracted by mini-css-extract-plugin
export default {"reactPlayer":"Template6_reactPlayer__7nKWC","heading":"Template6_heading__es7OG","description":"Template6_description__Kbd8H"};